"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAssociateContactPrefStateByEmail = updateAssociateContactPrefStateByEmail;
exports.updateUserContactPrefStateByEmail = updateUserContactPrefStateByEmail;
function updateUserContactPrefStateByEmail() {
  var cPreferences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: 'UPDATE_USER_CONTACT_PREF_STATE_BY_EMAIL',
    payload: cPreferences
  };
}
function updateAssociateContactPrefStateByEmail() {
  var cPreferences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: 'UPDATE_ASSOCIATE_CONTACT_PREF_STATE_BY_EMAIL',
    payload: cPreferences
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/actions/contactPreferencesActions.js
// module id = 2137
// module chunks = 9